
import { mapGetters, mapActions } from 'vuex';
import formItem from '@/component/form-item.vue';
import ycRodioGroup from '@/component/yc-radio-group.vue';
import pageHead from '@/component/page-header.vue';
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
components: {
formItem,
ycRodioGroup,
pageHead,
XDialog
},
name: 'ProveApply',
data() {
return {
value: '',
showdialog: false,
isChecked: 0,
radioList: [
{ radio: '邮寄', checked: true },
{ radio: '自取', checked: false }
]
};
},
methods: {
...mapActions([]),
proveApply() {
this.showdialog = true;
},
myApply() {
this.showdialog = false;
this.$router.push({
path: '/myApply'
});
},
back() {
this.showdialog = false;
this.$router.push({
path: '/'
});
}
},
watch: {},
computed: {
...mapGetters([])
},
created() {},
mounted() {
let elem = document.querySelector('#vux_view_box_body');
setTimeout(() => {
elem.style.paddingBottom = '0';
}, 10);
}
};
